import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
// RTKQ
// REDUCERS
import appSlice from './app.slice';
import userSlice from './user.slice';
import tokenSlice from './token.slice';
import notificationSlice from './notification.slice';
import { dataApi } from '../apis/rtkData.api';

const store = configureStore({
  reducer: {
    app: appSlice,
    user: userSlice,
    token: tokenSlice,
    notification: notificationSlice,
    [dataApi.reducerPath]: dataApi.reducer
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: false
    }).concat(dataApi.middleware);
  }
});
setupListeners(store.dispatch);

export default store;